import { render, staticRenderFns } from "./VlFilterElementHeader.vue?vue&type=template&id=f3db5288&scoped=true&"
import script from "./VlFilterElementHeader.vue?vue&type=script&lang=js&"
export * from "./VlFilterElementHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3db5288",
  null
  
)

export default component.exports